import { createContext, FunctionComponent, useContext, useMemo, useState } from 'react';
import { singleton } from '@/lib/singleton';
import { useLocalStorage } from '@/hooks/useLocalStorage';

export type WalletContext = {
    code: string | null;
    setCode: (code: string | null) => void;
    authCode: string | null;
    setAuthCode: (code: string | null) => void;
    signature: [string, string, string] | null;
    setSignature: (signature: [string, string, string] | null) => void;
    signedAddress: string | null;
    setSignedAddress: (address: string | null) => void;
};

const context = singleton(() => createContext<WalletContext | undefined>(undefined));

export const useWalletContext = (): WalletContext => {
    const contextValue = useContext(context());
    if (contextValue === undefined) {
        throw new Error(`Don't use this outside WalletContextProvider`);
    }
    return contextValue;
};

const STORAGE_VERSION = 'v1000001';
const generateStorageKey = (key: string): string => `${key}_${STORAGE_VERSION}`;
export const WalletContextProvider: FunctionComponent = ({ children }) => {
    const [signature, setSignature] = useLocalStorage<[string, string, string] | null>(
        generateStorageKey('onlyBotsSignature'),
        null
    );
    const [signedAddress, setSignedAddress] = useLocalStorage<string | null>(
        generateStorageKey('onlyBotsAddress'),
        null
    );

    // const [code, setCode] = useLocalStorage<string | null>(generateStorageKey('onlybotsCode'), null);
    const [code, setCode] = useState<string | null>(null);
    // const [authCode, setAuthCode] = useLocalStorage<string | null>(generateStorageKey('onlybotsAuthCode'), null);
    const [authCode, setAuthCode] = useState<string | null>(null);

    const contextValue = useMemo<WalletContext>(
        () => ({
            signature,
            setSignature,
            signedAddress,
            setSignedAddress,
            code,
            setCode,
            authCode,
            setAuthCode,
        }),
        [signature, setSignature, signedAddress, setSignedAddress, code, setCode, authCode, setAuthCode]
    );

    const { Provider } = context();
    return <Provider value={contextValue}>{children}</Provider>;
};
